var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerspectivesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9425 4.5H1.0575C0.777034 4.5 0.508054 4.61141 0.309735 4.80973C0.111415 5.00805 0 5.27703 0 5.5575V15.8175C0 16.098 0.111415 16.3669 0.309735 16.5653C0.508054 16.7636 0.777034 16.875 1.0575 16.875H16.9425C17.223 16.875 17.4919 16.7636 17.6903 16.5653C17.8886 16.3669 18 16.098 18 15.8175V5.5575C18 5.27703 17.8886 5.00805 17.6903 4.80973C17.4919 4.61141 17.223 4.5 16.9425 4.5Z",
    fill: "#0016E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8615 12.2704V13.4648C10.8615 13.7471 10.6306 13.9775 10.3484 13.9775H5.01325C4.73107 13.9775 4.5 13.7471 4.5 13.4648V8.51268C4.5 8.23051 4.73096 8 5.01325 8H10.3484C10.6306 8 10.8615 8.2304 10.8615 8.51268V9.69201V9.67551L13.544 8.41862V13.5391L10.8615 12.2704Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8289 0.5625C15.8289 0.413316 15.7696 0.270242 15.6641 0.164752C15.5586 0.0592632 15.4155 0 15.2664 0H2.89136C2.74217 0 2.5991 0.0592632 2.49361 0.164752C2.38812 0.270242 2.32886 0.413316 2.32886 0.5625V1.125H15.8289V0.5625Z",
    fill: "#0016E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9426 2.8125C16.9426 2.66332 16.8834 2.52024 16.7779 2.41475C16.6724 2.30926 16.5293 2.25 16.3801 2.25H1.75513C1.60594 2.25 1.46287 2.30926 1.35738 2.41475C1.25189 2.52024 1.19263 2.66332 1.19263 2.8125V3.375H16.9426V2.8125Z",
    fill: "#0016E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspectivesIcon);
export default __webpack_public_path__ + "static/media/perspectives-icon.96dc4b926defbf9e139929ca61699fd1.svg";
export { ForwardRef as ReactComponent };